//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '@/api/baseDataManage';
import Divier from '../contextmenu/divier';
import { rinkoImageUploads, rinkoImageView, rinkoImageDel, rinkoLook, rinkoBuLuSaveInfo } from '@/api/rinko';
import { getChilComList, getProductList, getCompanyList, getProductNameList } from '@/api/baseDate';
import currencyInput from '@/components/v-currencyInput/CurrencyInput';
export default {
  name: 'PolicyInfoBuLu',
  components: {
    Divier: Divier,
    currencyInput: currencyInput
  },
  data: function data() {
    var _this = this;

    return {
      dateTimeStartFunc1: {
        disabledDate: function disabledDate(time) {
          if (_this.downFrom.endDate) {
            return time.getTime() > new Date(_this.downFrom.endDate).getTime();
          }
        }
      },
      dateTimeEndFunc1: {
        disabledDate: function disabledDate(time) {
          if (_this.downFrom.startDate) {
            return time.getTime() < new Date(_this.downFrom.startDate).getTime() - 8.64e7;
          }
        }
      },
      // insuranceCompanyCode: 'IC0030',
      // insuranceCompanyName: '中国太平洋财产保险股份有限公司上海分公司',
      insuranceCompanyCode: '',
      insuranceCompanyName: '',
      // 保险公司多选
      options_insuranceCompanyName: [],
      options_companyName: [],
      // 币种多选
      options_currencyName: [{
        value: 'CNY',
        label: '人民币'
      }],
      // 产品多选
      options_productName: [{
        value: '1',
        label: '人身意外伤害保险'
      }, {
        value: '2',
        label: '出口产品责任保险'
      }, {
        value: '3',
        label: '关税保证保险'
      }, {
        value: '4',
        label: '货物运输保险'
      }, {
        value: '5',
        label: '企业财产保险'
      }, {
        value: '6',
        label: '安全生产责任保险'
      }, {
        value: '7',
        label: '出口贸易信用保险（短期）'
      }],
      // 表单信息
      downFrom: {
        applicationNo: '',
        // 投保意向申请单号
        proposalNo: '',
        // 投保单号
        policyNo: '',
        // 保单号
        productCode: '',
        // 产品名称(产品代码)
        productName: '',
        // 产品名称(产品代码)
        insuredName: '',
        // 被保险人名称（被保险人代码）
        insuranceCompanyCode: 'IC0030',
        // 保险公司（保险公司代码）
        insuranceCompanyName: '中国太平洋财产保险股份有限公司上海分公司',
        // 保险公司（保险公司代码）
        companyCode: '',
        // 分支机构（分支机构代码）
        companyName: '',
        // 分支机构（分支机构代码）
        startDate: '',
        // 起保日期
        endDate: '',
        // 终保日期
        sumAmount: '',
        // 总保额
        sumPremium: '',
        // 总保费（总保费代码）
        currency: '',
        // 币种（币种代码）
        currencyName: '',
        // 币种（币种代码）
        submitType: '' // 0-投保单信息补录 1-保单信息补录

      },
      rules: {
        sumAmount: [{
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入正确格式,可保留两位小数'
        }],
        sumPremium: [{
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入正确格式,可保留两位小数'
        }],
        proposalNo: [{
          required: true,
          message: '请输入投保单号',
          trigger: 'blur'
        }],
        policyNo: [{
          required: true,
          message: '请输入保单号',
          trigger: 'blur'
        }],
        productName: [{
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }],
        insuredName: [{
          required: true,
          message: '请输入被保险人名称',
          trigger: 'blur'
        }],
        insuranceCompanyCode: [{
          required: true,
          message: '请选择保险公司',
          trigger: 'blur'
        }],
        companyName: [{
          required: true,
          message: '请选择分支机构',
          trigger: 'blur'
        }],
        startDate: [{
          required: true,
          message: '请输入起保日期',
          trigger: 'blur'
        }],
        endDate: [{
          required: true,
          message: '请输入终保日期',
          trigger: 'blur'
        }]
      },
      // 上传
      upLoadFlag: true,
      imageShowFlag: true,
      // 是否显示影像文件上传
      isView: false,
      fileList: [],
      isList1: false,
      fileList1: [],
      fileList2: [],
      options2: [],
      upimgsNum: 0,
      isUpimg: false,
      fileListZ: [],
      fileListF: {
        imagUse: '',
        imagUseType: '',
        name: '',
        imagUseName: ''
      },
      dialogImageUrl: ''
    };
  },
  // 计算属性
  computed: {
    // 禁用标识符
    disabledFlag: function disabledFlag() {
      return this.$route.query.proposalNo === undefined;
    },
    viewFlag: function viewFlag() {
      return this.$route.params.type === 'view';
    }
  },
  // 初始化方法
  created: function created() {
    var _this2 = this;

    var type = this.$route.params.type;

    if (type === 'view') {
      this.downFrom.applicationNo = this.$route.params.applicationNo;
      this.downFrom.proposalNo = this.$route.params.proposalNo;
    } else {
      var applicationNoData = this.$route.query.applicationNo;
      this.downFrom.proposalNo = this.$route.query.proposalNo;
      this.productNameList(applicationNoData);
    }

    rinkoLook({
      'proposalNo': this.downFrom.proposalNo
    }).then(function (res) {
      if (type === 'view') {
        _this2.downFrom = res;
        _this2.downFrom.applicationNo = _this2.$route.params.applicationNo;
        _this2.downFrom.proposalNo = _this2.$route.params.proposalNo;
      } else {
        _this2.downFrom.applicationNo = _this2.$route.query.applicationNo;
        _this2.downFrom.proposalNo = _this2.$route.query.proposalNo;
      }

      if (res.rinkoImageList != null) {
        _this2.upimgsNum = res.rinkoImageList.length;

        for (var i = 0; i < res.rinkoImageList.length; i++) {
          var obj = {};
          var formData = new FormData();
          var base64 = 'data:image/png;base64,' + res.rinkoImageList[i].base64;
          var base64url = res.rinkoImageList[i].base64;
          var imagCode = res.rinkoImageList[i].imagCode;
          var proposalNo = res.rinkoImageList[i].proposalNo;
          var claimCode = res.rinkoImageList[i].claimCode;
          var fileSrc = res.rinkoImageList[i].imagUrl;
          var fileName = res.rinkoImageList[i].fileName;
          var imagUseType = res.rinkoImageList[i].imagUseType; // 转换base64到file

          var toFile = require('data-uri-to-file');

          toFile(base64).then(function (filed) {
            formData.append('imageName', filed);
            obj.raw = filed;
          });
          obj['type'] = 'old';
          obj['url'] = base64;
          obj.imagCode = imagCode;
          obj.proposalNo = proposalNo;
          obj.claimCode = claimCode;
          obj.base64url = base64url;
          obj.fileSrc = fileSrc;
          obj.name = fileName;

          if (imagUseType == '7') {
            _this2.fileList1.push(obj);
          } else if (imagUseType == '8') {
            _this2.fileList2.push(obj);
          }
        }
      }
    });
    var list = this.$store.state.user.userinfo.insuranceCompanyList || [];
    var companyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || '';
    this.get_select(list, companyCode);
    this.restaurants = this.loadAll(); //默认第一个保险公司

    this.downFrom.insuranceCompanyCode = this.options_insuranceCompanyName[0].value || '';
    this.downFrom.insuranceCompanyName = this.options_insuranceCompanyName[0].label || '';
    this.Init_get();
  },
  methods: {
    // 初始化方法
    Init_get: function Init_get() {
      var data = this.downFrom; // 投保意向单号

      data.applicationNo = this.downFrom.applicationNo; // 保单号

      data.policyNo = this.downFrom.policyNo; // 投保单号

      data.proposalNo = this.downFrom.proposalNo; // 产品代码

      data.productCode = this.downFrom.productCode; // 产品名称

      data.productName = this.downFrom.productName; // 被保险人名称

      data.insuredName = this.downFrom.insuredName; // 保险公司代码

      data.insuranceCompanyCode = this.downFrom.insuranceCompanyCode; // 保险公司名称

      data.insuranceCompanyName = this.downFrom.insuranceCompanyName; // 分支机构代码

      data.companyCode = this.downFrom.companyCode; // 分支机构名称

      data.companyName = this.downFrom.companyName; // 起保日期

      data.startDate = this.downFrom.startDate; // 终保日期

      data.endDate = this.downFrom.endDate; // 保额

      data.sumAmount = this.downFrom.sumAmount; // 保费

      data.sumPremium = this.downFrom.sumPremium; // 币种

      data.currency = this.downFrom.currency; // 币种名称

      data.currencyName = this.downFrom.currencyName;
    },
    // 分支机构
    companyCode_ch: function companyCode_ch(val) {
      var obj = {};
      obj = this.options_companyName.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.downFrom.companyName = obj.label;
    },
    //产品名称
    productName_ch: function productName_ch(val) {
      debugger;
      var object = {};
      object = this.options_productName.find(function (item) {
        return item.value === val;
      });
      this.downFrom.productName = object.label;
    },
    // ------下拉信息
    get_select: function get_select(list, code) {
      this.findInsuranceCompany_fun(list);
      this.companyqueryAll_fun(code);
    },
    // 保险公司
    findInsuranceCompany_fun: function findInsuranceCompany_fun(list) {
      this.options_insuranceCompanyName = [];

      for (var i = 0; i < list.length; i++) {
        var obj = {};

        if (list) {
          obj.value = list[i].insuranceCompanyCode || '';
          obj.label = list[i].insuranceCompanyName || '';
          this.options_insuranceCompanyName.push(obj);
        }
      } // this.options_insuranceCompanyName = []
      // for (var i = 0; i < list.length; i++) {
      //   var obj = {}
      //   obj.value = list[i].insuranceCompanyCode
      //   obj.label = list[i].insuranceCompanyName
      //   if (!obj.value || !obj.label) {
      //     this.options_insuranceCompanyName = []
      //   } else {
      //     this.options_insuranceCompanyName.push(obj)
      //   }
      // }
      // var data = {
      //   insuranceCompanyCode: code
      // }
      // getCompanyList(data).then(res => {
      //   this.options_insuranceCompanyName = []
      //   for (var i = 0; i < res.length; i++) {
      //     console.log(res)
      //     var obj = {}
      //     obj.value = res[i].insuranceCompanyCode
      //     obj.label = res[i].insuranceCompanyName
      //     if (!obj.value || !obj.label) {
      //       this.options_insuranceCompanyName = []
      //     } else {
      //       this.options_insuranceCompanyName.push(obj)
      //     }
      //   }
      // })

    },
    // 产品名称
    productNameList: function productNameList(applicationNoData) {
      var _this3 = this;

      this.options_productName = [];
      var data = {
        applicationNo: applicationNoData
      }; // var applicationNo = applicationNoData

      getProductNameList(data).then(function (res) {
        _this3.options_productName = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].productCode;
          obj.label = res[i].productName;

          _this3.options_productName.push(obj);
        }
      });
    },
    // 币种
    currency_ch: function currency_ch() {},
    // 保险公司
    insuranceCompanyCode_ch: function insuranceCompanyCode_ch(val) {
      var obj = {};
      obj = this.options_insuranceCompanyName.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据
      });
      this.downFrom.insuranceCompanyName = obj.label; // 查询保险公司下的分支机构

      this.companyqueryAll_fun(val);
      this.riskqueryAll_fun(val);
    },
    // 产品名称
    riskqueryAll_fun: function riskqueryAll_fun(code) {
      var _this4 = this;

      this.options2 = [];
      var data = {
        insuranceCompanyCode: code
      };
      getProductList(data).then(function (res) {
        _this4.options2 = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].riskCode;
          obj.label = res[i].riskName;

          _this4.options2.push(obj);
        }

        console.log(_this4.options2);
      });
    },
    // 分支机构
    companyqueryAll_fun: function companyqueryAll_fun(code) {
      var _this5 = this;

      var data = {
        insuranceCompanyCode: code || ''
      };
      getChilComList(data).then(function (res) {
        _this5.options_companyName = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].companyCode;
          obj.label = res[i].companyName;

          _this5.options_companyName.push(obj);
        }
      });
    },
    // 提交
    tempBtn: function tempBtn(val, type) {
      var _this6 = this;

      if (this.fileList1.length > 0) {
        if (!this.isList1) {
          this.$message({
            message: '请先上传【投保单等投保文件】中的影像信息',
            type: 'error'
          });
          return;
        }
      }

      if (this.fileList2.length > 0) {
        if (!this.isList1) {
          this.$message({
            message: '请先上传【电子保单等承保文件】中的影像信息',
            type: 'error'
          });
          return;
        }
      }

      debugger;
      console.log(this.$refs['downFrom']);
      var myFalg1 = true;

      if (type == '1') {
        this.$refs['downFrom'].validate(function (valid) {
          if (!valid) {
            _this6.$message({
              type: 'warning',
              message: '基本信息必填项不能为空'
            });

            myFalg1 = false;
          }
        });
      }

      if (myFalg1) {
        this.$confirm('请确认是否提交该保单信息', '提示', {
          confirmButtonText: '确认提交',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this6.downFrom.submitType = type;
          var data = _this6.downFrom;

          if (_this6.downFrom.currencyName === 'CHN') {
            data.currency = _this6.downFrom.currencyName;
            data.currencyName = '人民币';
          }

          rinkoBuLuSaveInfo(data).then(function (res) {
            if (_this6.downFrom.proposalNo == null) {
              _this6.$message({
                message: '请录入投保单号后提交',
                type: 'error'
              });

              return;
            }

            if (res.resultCode == '0000') {
              _this6.$message({
                message: res.resultMessage,
                type: 'success'
              });

              _this6.$router.go('-1'); // 关闭导航栏


              _this6.$store.dispatch('delVisitedViews', _this6.$route);
            } else if (res.resultCode == '9999') {
              _this6.$message({
                message: res.resultMessage,
                type: 'error'
              });
            }
          });
        }).catch(function () {
          _this6.$message({
            type: 'info',
            message: '已取消保单提交'
          });
        });
      }
    },
    // 取消
    close_but: function close_but() {
      // 返回上一步路由
      this.$router.go(-1);
      this.$store.dispatch('delVisitedViews', this.$route);
    },
    // 点击影像上传
    upFile: function upFile() {
      this.upLoadFlag = true;
      console.log('点击影像上传');
    },
    // 提交上传信息
    submitUpload1: function submitUpload1() {
      var _this7 = this;

      var formData = new FormData();
      formData.append('proposalNo', this.downFrom.proposalNo);
      formData.append('insuranceCompanyCode', this.insuranceCompanyCode);
      formData.append('insuranceCompanyName', this.insuranceCompanyName);
      this.fileList = [];

      for (var i = 0; i < this.fileList1.length; i++) {
        this.fileList.push(this.fileList1[i]);
        this.fileListF = {};
        this.fileListF.imagUse = '2';
        this.fileListF.imagUseType = '7';
        this.fileListF.name = this.fileList1[i].name;
        this.fileListF.imagUseName = this.fileList1[i].imagUseName;
        this.fileListZ.push(this.fileListF);
      }

      for (var _i = 0; _i < this.fileList2.length; _i++) {
        this.fileList.push(this.fileList2[_i]);
        this.fileListF = {};
        this.fileListF.imagUse = '3';
        this.fileListF.imagUseType = '8';
        this.fileListF.name = this.fileList2[_i].name;
        this.fileListF.imagUseName = this.fileList2[_i].imagUseName;
        this.fileListZ.push(this.fileListF);
      }

      formData.append('fileLis', JSON.stringify(this.fileListZ)); // 影像列表

      if (this.fileList.length > 0) {
        var m = 0;
        var newarray = [];

        for (var _j = 0; _j < this.fileList.length; _j++) {
          var status = 0;

          for (var _i2 = 0; _i2 < this.fileList.length; _i2++) {
            if (this.fileList[_j].name == this.fileList[_i2].name) {
              status = status + 1;
            }

            if (status > 1) {
              this.$message({
                message: '上传文件名字有重复，请确认！ 重复文件名：' + this.fileList[_i2].name,
                type: 'error'
              });
              return;
            }
          }
        }

        for (var j = 0; j < this.fileList.length; j++) {
          if (this.fileList[j].raw && this.fileList[j].type != 'old') {
            if (m < 10) {
              formData.append('files', this.fileList[j].raw);
              this.fileList[j]['type'] = 'old';
            }

            m++;
          }
        }

        rinkoImageUploads(formData).then(function (res) {
          if (res.rtnCode == '0000') {
            _this7.$message({
              message: res.data,
              type: 'success'
            });

            _this7.isList1 = true;
            var k = 0;

            for (var i = 0; i < _this7.fileList.length; i++) {
              if (!_this7.fileList[i].imagCode && k < 10) {
                _this7.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
                _this7.fileList[i].imagCode = res.detailDtoList[k].imagCode;
                _this7.fileList[i].base64url = res.detailDtoList[k].base64Src;
                _this7.fileList[i].proposalNo = res.detailDtoList[k].proposalNo;
                _this7.fileList[i].claimCode = _this7.claimCode;
                newarray.push(_this7.fileList[i]);
                k++;
              }
            }

            console.log(newarray.length);

            if (newarray.length > 9) {
              _this7.submitUpload3();
            } else {
              $('.el-upload-list__item-status-label').css('display', 'block');

              _this7.$message({
                message: res.data,
                type: 'success'
              });

              _this7.upimgsNum = _this7.fileList.length;
              _this7.isUpimg = true;
            }
          } else {
            _this7.$message({
              message: '没有待上传的影像',
              type: 'error'
            });
          }
        }, function (res) {});
      } else {
        this.$message({
          message: '没有待上传的影像',
          type: 'error'
        });
      }
    },
    submitUpload3: function submitUpload3() {
      var _this8 = this;

      if (this.fileList.length > 0) {
        var formData = new FormData();
        formData.append('proposalNo', this.downFrom.proposalNo);
        formData.append('insuranceCompanyCode', this.insuranceCompanyCode);
        formData.append('insuranceCompanyName', this.insuranceCompanyName);

        for (var i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].raw && this.fileList[i].type != 'old') {
            formData.append('files', this.fileList[i].raw);
            this.fileList[i]['type'] = 'old';
          }
        }

        formData.append('fileLis', JSON.stringify(this.fileListZ));
        rinkoImageUploads(formData).then(function (res) {
          if (res.rtnCode == '0000') {
            $('.el-upload-list__item-status-label').css('display', 'block');

            _this8.$message({
              message: res.data,
              type: 'success'
            });

            _this8.isList1 = true;
            _this8.upimgsNum = _this8.fileList.length;
            _this8.isUpimg = true;
            var k = 0;

            for (var i = 0; i < _this8.fileList.length; i++) {
              if (!_this8.fileList[i].imagCode) {
                _this8.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
                _this8.fileList[i].imagCode = res.detailDtoList[k].imagCode;
                _this8.fileList[i].base64url = res.detailDtoList[k].base64Src;
                _this8.fileList[i].proposalNo = res.detailDtoList[k].proposalNo;
                _this8.fileList[i].claimCode = _this8.claimCode;
                k++;
              }
            }
          } else {
            _this8.$message({
              message: '没有待上传的影像',
              type: 'error'
            });
          }
        }, function (res) {});
      } else {
        this.$message({
          message: '没有待上传的影像',
          type: 'error'
        });
      }
    },
    httpRequest: function httpRequest(data) {},
    // 图片上传成功后
    success_img1: function success_img1(response, file, fileList) {
      this.fileList1 = fileList;
    },
    success_img2: function success_img2(response, file, fileList) {
      this.fileList2 = fileList;
    },
    // 图片删除时1
    handleRemove1: function handleRemove1(file, fileList) {
      var _this9 = this;

      var formData = new FormData();
      var objimg = {
        rinkoImageDetailDtoList: [{
          base64Src: file.base64url,
          claimCode: this.claimCode,
          fileName: file.name,
          fileSrc: file.fileSrc,
          imagCode: file.imagCode
        }]
      };
      rinkoImageDel(objimg).then(function (res) {
        _this9.fileList1 = fileList;
      });
    },
    // 图片删除时1
    handleRemove2: function handleRemove2(file, fileList) {
      var _this10 = this;

      var formData = new FormData();
      var objimg = {
        rinkoImageDetailDtoList: [{
          base64Src: file.base64url,
          claimCode: this.claimCode,
          fileName: file.name,
          fileSrc: file.fileSrc,
          imagCode: file.imagCode
        }]
      };
      rinkoImageDel(objimg).then(function (res) {
        _this10.fileList2 = fileList;
      });
    },
    // 图片上传时
    handlePictureCardPreview1: function handlePictureCardPreview1(file) {
      this.fileList1.push(file);
    },
    // 图片上传时
    handlePictureCardPreview2: function handlePictureCardPreview2(file) {
      this.fileList2.push(file);
    },
    // 判断上传影像文件类型
    beforeUploadimg1: function beforeUploadimg1(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; // 判断文件名是否重复

      var count = 0;
      this.fileList1.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    // 判断上传影像文件类型
    beforeUploadimg2: function beforeUploadimg2(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; // 判断文件名是否重复

      var count = 0;
      this.fileList2.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    jumpTo: function jumpTo() {
      console.log('123');
      var params = {
        type: 'view',
        applicationNo: this.downFrom.applicationNo
      };
      this.$router.push({
        path: "/rinkoPlatInsurance/insuranceApplyFor/".concat(params.type, "/").concat(params.applicationNo)
      });
    },
    look_img: function look_img(file) {
      if (file.fileSrc == undefined || file.fileSrc == '') {
        console.log('未上传到服务器');
        this.$message({
          message: '请检查该文件是否已经进行上传影像',
          type: 'warning'
        });
      } else {
        var data = {
          fileSrc: file.fileSrc
        };
        rinkoImageView(data).then(function (res) {
          var blob = new Blob([res], {
            type: ''
          });
          var url = window.URL.createObjectURL(blob);
          console.log(url);
          var link = document.createElement('a'); // 创建a标签

          link.href = url;
          link.download = file.name; // 重命名文件

          link.click();
          URL.revokeObjectURL(url); // 释放内存
        });
      }
    }
  }
};